import SchoolTermData from './SchoolTermData';

export default SchoolTermData;
